<ng-container *transloco="let translate">
    <div class="flex items-center justify-between w-full mx-auto px-4 py-2 pb-4">
        <h1 class="text-xl font-semibold" [textContent]="translate('Integration Status')"></h1>
        <material-button class="p-2 rounded-full" [buttonType]="'icon'" [size]="'small'" [titleText]="'Close'" [prefixIcon]="'close'" [classList]="['focus:!outline-none', 'hover:!bg-gray-100']" (buttonClicked)="closeModal()"></material-button>
    </div>
    <mat-dialog-content class="w-full h-[76%] overflow-auto px-4 py-2 relative !left-[15px]">
        <div class="flex flex-col justify-center items-center h-full">
            <div class="w-[250px] h-[150px] relative shadow-lg rounded-md overflow-hidden">
                <div class="text-lg font-bold p-[10px] text-white text-[15px] text-center bg-[#828387]" [textContent]="'Integration Status'"></div>
                <div class="mt-2 text-center">
                    <div class="mt-3">
                        <span [textContent]="translate('Status') + ' -'"></span>
                        <span [ngClass]="changeTextColor(integrationStatus)" class="font-bold" [textContent]="integrationStatus">
                        </span>
                    </div>
                    <div class="mt-3">
                        <material-button *ngIf="integrationStatus === 'Failed'" [text]="translate('Re-run Integration')" [color]="'primary'" (buttonClicked)="fetchIntegrationRetryStatus()"></material-button>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="!min-h-0 flex justify-center items-center max-h-[30px]">
        <material-button [text]="translate('Close')" (buttonClicked)="closeModal()"></material-button>
    </mat-dialog-actions>
</ng-container>
